export default __webpack_public_path__ + "static/media/logo-main.562f6181.png";